import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ENABLE_BASKET_DEAL_PRODUCT_GIFTING_FULL } from '../../brands/default/features';
import { trackEvent } from '../../helpers/analytics';
import { updateProductGifting } from '../../redux/actions/basket';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';
import useToast from '../_generic/toast/UseToast';
import BasketDealProductGiftingFull from './BasketDealProductGiftingFull';

export default function BasketDealProductGifting({
  bt,
  giftingOptions,
  giftWrap,
  isBookingCalendarOnRedemptionDeal = false,
  isBookingCalendarOnRedemptionGift = false,
  isChannelManagerDeal,
  product,
}) {
  const toast = useToast();
  const dispatch = useDispatch();
  const disabled = useSelector(
    (state) =>
      state.checkout.status === CHECKOUT_STATUS.UPDATING ||
      state.checkout.status === CHECKOUT_STATUS.REFRESHING,
  );
  const giftPackPreset = useSelector((state) => state.checkout.giftingConfig);
  const checkoutData = useSelector((state) => state.checkout.checkoutData);
  const [giftPackPrice, setGiftPackPrice] = useState({});

  useEffect(() => {
    const temporaryGiftPackPriceObject = {};
    if (checkoutData?.giftingDetails) {
      Object.keys(checkoutData.giftingDetails).forEach((giftValue) => {
        if (checkoutData.giftingDetails[giftValue].priceIncludingPostage) {
          temporaryGiftPackPriceObject[giftValue] =
            checkoutData.giftingDetails[giftValue].priceIncludingPostage;
        }
      });
      setGiftPackPrice(temporaryGiftPackPriceObject);
    }
  }, [checkoutData.giftingDetails]);
  const onUpdate = (value) => {
    trackEvent(`${value}Selected`);

    dispatch(
      updateProductGifting(
        bt,
        giftWrap,
        product,
        value,
        toast,
        giftPackPreset,
        checkoutData,
      ),
    );
  };

  if (
    (!product.gift &&
      isBookingCalendarOnRedemptionGift &&
      !ENABLE_BASKET_DEAL_PRODUCT_GIFTING_FULL) ||
    (!product.gift &&
      (isBookingCalendarOnRedemptionGift ||
        isBookingCalendarOnRedemptionDeal ||
        isChannelManagerDeal))
  ) {
    return null;
  }

  return (
    <BasketDealProductGiftingFull
      disabled={disabled}
      giftPackPrice={giftPackPrice}
      giftingOptions={giftingOptions}
      isBookingCalendarOnRedemptionGift={isBookingCalendarOnRedemptionGift}
      onUpdate={onUpdate}
      product={product}
    />
  );
}

BasketDealProductGifting.propTypes = {
  bt: PropTypes.string,
  giftingOptions: PropTypes.array,
  giftWrap: PropTypes.object,
  isBookingCalendarOnRedemptionDeal: PropTypes.bool,
  isBookingCalendarOnRedemptionGift: PropTypes.bool,
  isChannelManagerDeal: PropTypes.bool,
  product: PropTypes.object,
};
